import {
  Directive,
  ElementRef,
  Inject, Input
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';
import {ApplicationValidatorService} from '../../services/application/application-validator.service';
import {reactiveFormValidator} from '../Reactive-form-validation-trigger';
import {MatExpansionPanel} from '@angular/material/expansion';

@Directive({
  selector: '[appInvalidControlScroll]'
})
export class InvalidControlScrollDirective {

  @Input() formScroll: FormGroup;
  @Input() accordionReference: MatExpansionPanel;

  constructor(
    private el: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private applicationFormValidatorService: ApplicationValidatorService
  ) {
    this.applicationFormValidatorService.getInvalidControlScrollObservable().subscribe((value) => {
      if (value) {
        if (this?.formScroll?.invalid) {
          this.scrollToFirstInvalidControl(this.accordionReference);
        }
      }
    });
  }

  private get containerEl(): HTMLElement {
    return this.el.nativeElement;
  }

  private scrollToFirstInvalidControl(hasAccordion) {
    reactiveFormValidator(this.formScroll);

    const firstInvalidControl: HTMLElement = document.querySelector(
      '[formcontrolname].ng-invalid'
    );
    if (!firstInvalidControl) {
      return;
    }
    if (hasAccordion) {
      this.accordionReference.open();
      this.scrollIntoView(firstInvalidControl);
    } else {
      const attributeNode = firstInvalidControl.getAttributeNode('formControlName')?.value;
      if (attributeNode === 'legalBusinessName') {
        const element = document.getElementsByClassName('js-pagination-active');
        const nextElement: HTMLElement = element?.[0]?.nextSibling as HTMLElement;
        if (nextElement.classList && nextElement.classList.contains('js-pagination')) {
          nextElement.click();
        }
      } else {
        this.scrollIntoView(firstInvalidControl);
      }
    }

    this.focusInvalidControl(firstInvalidControl);
  }

  scrollIntoControl(firstInvalidControl: HTMLElement) {
    const layoutRouter = document.querySelector('.layout--router');
    layoutRouter.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth'
    });
  }

  scrollIntoView(firstInvalidControl: HTMLElement) {
    firstInvalidControl.scrollIntoView({
      behavior: 'smooth'
    });
  }

  focusInvalidControl(firstInvalidControl: HTMLElement) {
    const layoutRouter = document.querySelector('.layout--router');
    if (!layoutRouter) {
      firstInvalidControl?.focus();
      return;
    }
    fromEvent(layoutRouter, 'scroll')
      .pipe(
        debounceTime(100),
        take(1)
      )
      .subscribe(() => {
        firstInvalidControl?.focus();
      });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    const controlElTop = controlEl?.getBoundingClientRect().top;
    if (this.containerEl) {
      const containerTop = this.containerEl.getBoundingClientRect().top;
      const absoluteControlElTop = controlElTop + this.containerEl.scrollTop;
      return absoluteControlElTop - containerTop - labelOffset;
    } else {
      const absoluteControlElTop = controlElTop + window.scrollY;
      return absoluteControlElTop - labelOffset;
    }
  }
}
